module.exports = __webpack_public_path__ + "img/img8.658c138f.jpg";